import { useTranslation } from 'react-i18next';
import type { DailyRouteActivity } from '@apis/reports';
import { PanelCard } from '../../shared/PanelCard/PanelCard';
import { DataRow } from '../../shared/DataRow/DataRow';
import type { IPanelQuery } from '../../shared/types';
import classes from './ActivitiesPanel.module.css';

interface IActivitiesPanelProps {
  query: IPanelQuery<DailyRouteActivity[]>;
}

export function ActivitiesPanel({ query }: IActivitiesPanelProps) {
  const { t } = useTranslation();
  const title = t('reports.observeLocation.section.activities');

  if (query.isLoading) {
    return (
      <PanelCard aria-busy="true" aria-label={title}>
        <h4 className={classes.title}>{title}</h4>
      </PanelCard>
    );
  }

  if (query.isError) {
    return (
      <PanelCard role="alert" aria-label={title}>
        <h4 className={classes.title}>{title}</h4>
        <div className={classes.errorWrap}>
          {t('reports.observeLocation.errorRetry')}
          <button
            type="button"
            className={classes.retry}
            onClick={() => query.refetch()}
          >
            {t('reports.observeLocation.retry')}
          </button>
        </div>
      </PanelCard>
    );
  }

  const items = query.data ?? [];

  return (
    <PanelCard aria-label={title}>
      <h4 className={classes.title}>{title}</h4>
      {items.length === 0 ? (
        <div className={classes.empty}>
          {t('reports.observeLocation.empty.activities')}
        </div>
      ) : (
        <ul className={classes.list}>
          {items.map((a) => (
            <DataRow
              key={a.activityId}
              label={a.name}
              chip={{ text: a.professionName, backgroundColor: a.professionColor }}
            />
          ))}
        </ul>
      )}
    </PanelCard>
  );
}
